const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const deepCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj))
}

export { sleep, deepCopy, }